<template>
  <div>
    <div class="form-group row" ref="formRow" v-if="label">
      <label :class="['col-form-label', 'col-sm-12']">{{label}}
        <a v-show="helpTip" rel="tooltip" @click.prevent="" data-toggle="tooltip" data-placement="right" :title="helpTip"><i class="far fa-info-circle" style="color: #C0C0C0;"></i></a>
      </label>
    </div>
    <div :class="{'row': true, 'form-group': !label}">
      <div class="col-sm-12">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormRowFull',
  props: {
    label: String,
    helpTip: {
      type: String,
      default: ''
    }
  },
};
</script>